import { Image, StyleSheet, View } from "@react-pdf/renderer";

import BackgroundImage from './BackgroundForFreeSpace.png';

export const EmptySpaceImage = () => (
  <View style={styles.wrap} fixed>
    <Image
      src={BackgroundImage}
      style={{
        position: 'absolute',
        left: -35,
        right: -35,
        top: 100,
        objectFit: 'cover',
        objectPositionX: 0,
        objectPositionY: 0,
        overflow: 'hidden',
      }}
    />
  </View>
);

const styles = StyleSheet.create({
  wrap: {
    flexGrow: 100,
    position: 'relative',
  },
  image: {
    position: 'absolute',
    left: -35,
    right: -35,
    top: 0,
    objectFit: 'cover',
    objectPositionX: 0,
    objectPositionY: 0,
    overflow: 'hidden',
  }
});